module.exports = __webpack_public_path__ + "static/img/home-banners-mob.fc50d8b6.jpg";